import { Injectable } from '@angular/core';
import { Actions } from '@ngrx/effects';
import { createApiCallEffects } from '../../../../common/store/generic.effects';
import {
  UserWorkAttendanceAction,
  userWorkAttendanceActions,
} from './user-work-attendance.actions';
import { UserWorkAttendanceApiService } from './user-work-attendance.api.service';

@Injectable()
export class UserWorkAttendanceEffects {
  constructor(
    private readonly userWorkAttendanceApiService: UserWorkAttendanceApiService,
    private readonly action$: Actions<UserWorkAttendanceAction>,
  ) {}

  getRegularity = createApiCallEffects(
    this,
    this.action$,
    userWorkAttendanceActions.getRegularity,
    this.userWorkAttendanceApiService.getRegularity,
  );

  getUsers = createApiCallEffects(
    this,
    this.action$,
    userWorkAttendanceActions.getUsers,
    this.userWorkAttendanceApiService.getUsers,
  );

  getSalesPersonRegularity = createApiCallEffects(
    this,
    this.action$,
    userWorkAttendanceActions.getSalesPersonRegularity,
    this.userWorkAttendanceApiService.getRegularity,
  );

  getSalesPersonUsers = createApiCallEffects(
    this,
    this.action$,
    userWorkAttendanceActions.getSalesPersonUsers,
    this.userWorkAttendanceApiService.getUsers,
  );
}
